import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'

import BlockMedia from '../BlockMedia/BlockMedia'
import Button from '../Button/Button'
import ButtonDownload from '../ButtonDownload/ButtonDownload'
import CardNews from '../CardNews/CardNews'
import Carousel from '../Carousel/Carousel'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import Heading from '../Heading/Heading'
import {
  StyledCarrouselControls,
  StyledCarrouselHeader,
  StyledSlider,
} from '../Carousel/Carousel.styled'
import { StyledH3 } from '../Heading/Heading.styled'
import { StyledIconButton } from '../IconButton/IconButton'
import { StyledImageContainer } from '../CardImage/CardImage.styled'
import { StyledParagraph } from '../CardNews/CardNews.styled'

export const StyledContainer = styled.section`
  display: flex;
  max-width: ${pxToRem(1200)};
  margin: ${pxToRem(70)} auto ${pxToRem(70)} auto;
  gap: ${pxToRem(40)};

  @media ${deviceMax.tablet} {
    align-items: center;
    flex-direction: column;
    gap: ${pxToRem(20)};
  }
`

export const StyledWhiteBlock = styled.div`
  display: flex;
  gap: ${pxToRem(40)};
  flex: 1;
  min-height: fit-content;
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(40)};
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.tablet} {
    flex-direction: column;
    gap: ${pxToRem(20)};
    padding: ${pxToRem(20)};
  }
`

export const StyledInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${pxToRem(40)};

  @media ${deviceMax.tablet} {
    gap: ${pxToRem(20)};
  }
`

export const StyledTopContainer = styled.div``

export const StyledBottomContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: ${pxToRem(20)};
  width: 100%;

  @media ${deviceMax.tablet} {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const StyledRichText = styled(CKEditorContent)`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH5};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH5};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  text-align: ${({ $alignment }) => ($alignment ? $alignment : 'left')};
  color: ${({ theme }) => theme.colors.opacity.black70};

  figure {
    margin-bottom: ${pxToRem(20)};
  }
`

export const StyledHeading = styled(Heading)`
  margin-bottom: ${pxToRem(10)};
`

export const StyledButtonDownload = styled(ButtonDownload)`
  min-width: ${pxToRem(374)};
  margin: initial;

  @media ${deviceMax.mobileL} {
    min-width: initial;
    max-width: 100%;
    width: 100%;
  }
`

export const StyledDocuments = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;

  @media ${deviceMax.mobileL} {
    width: 100%;
  }
`

export const StyledCtaButton = styled(Button)`
  justify-content: center;
  height: ${pxToRem(50)};
  width: fit-content;

  @media ${deviceMax.mobileM} {
    width: 100%;
  }
`

export const StyledSeparator = styled.div`
  height: auto;
  min-width: 1px;
  background-color: ${({ theme }) => theme.colors.main.grayLight};

  @media ${deviceMax.tablet} {
    width: 100%;
    min-height: 1px;
  }
`

export const StyledMedia = styled(BlockMedia)`
  min-width: ${pxToRem(383)};
  height: ${pxToRem(250)};

  @media ${deviceMax.tablet} {
    min-width: 100%;
    height: auto;
    max-height: ${pxToRem(250)};
    margin: initial;
  }
`

export const StyledCardNews = styled(CardNews)`
  height: 100%;
  max-height: ${pxToRem(363)};
  margin: 0;
  padding: ${pxToRem(10)};
  background-color: transparent;
`

export const StyledCarousel = styled(Carousel)`
  display: flex;
  flex-direction: column-reverse;
  gap: ${pxToRem(16)};
  width: ${pxToRem(384)};
  margin: initial;
  padding: initial;
  background-color: transparent;

  .slick-slide {
    height: initial;
  }

  .slick-slide > div {
    height: 100%;
  }

  .slick-track {
    align-items: stretch;
  }

  ${StyledImageContainer}, ${StyledH3}, ${StyledParagraph} {
    margin: initial;
  }

  ${StyledH3} {
    height: initial;
  }

  ${StyledCarrouselHeader} {
    margin: initial;
  }

  ${StyledCarrouselControls} {
    width: 100%;
    margin: 0 ${pxToRem(16)} 0 ${pxToRem(8)};
  }

  ${StyledIconButton}:nth-last-child(2) {
    margin-left: auto;
  }

  ${StyledSlider} {
    width: 100%;
    border-top: 3px solid ${({ theme }) => theme.colors.primary.lime};
    border-radius: ${pxToRem(5)};
    background-color: ${({ theme }) => theme.colors.unique.white};
  }

  @media ${deviceMax.tablet} {
    width: 100%;
    max-width: ${pxToRem(384)};
  }

  @media ${deviceMax.mobileM} {
    width: 100%;
    max-width: calc(100vw - 40px);
  }
`
